import toast from 'react-hot-toast';
import { getFilenameFromContentDisposition } from './getFilenameFromContentDisposition';
import i18n from 'i18next';

export type HandleFileDownloadOptions = {
  filename?: string;
};

export const handleFileDownload = async (response: Response, options?: HandleFileDownloadOptions) => {
  if (response.status !== 401) {
    if (response.status === 204) {
      toast.error(i18n.t('toast.no_data', { ns: 'common' }));
      return;
    }

    if (response.status === 200) {
      const blob = await response.blob();
      const filename = options?.filename ?? getFilenameFromContentDisposition(response.headers.get('content-disposition'));
      const a = document.createElement('a');
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      if (filename) a.download = filename;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
      toast.success(i18n.t('toast.success', { ns: 'productionLine' }));
      return;
    }

    if (response.status === 409) {
      toast.error(i18n.t('toast.conflict', { ns: 'productionLine' }));
      return;
    }

    toast.error(i18n.t('toast.problem', { ns: 'productionLine' }));
  }

  return;
};
